export default "/_next/static/images/img2-ebae46fab1d6c584c0e01367ace46fa7.png";